import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=6f70f3f7&scoped=true"
import script from "./Index.vue?vue&type=script&setup=true&lang=js"
export * from "./Index.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f70f3f7",
  null
  
)

export default component.exports